define('externalDependencies/configuration/clientApiConfiguration',['settings/settings'], function() {
    let ClientApiConfigurationSingleton = function() {
        if (ClientApiConfigurationSingleton.prototype._singletonInstance) {
            return ClientApiConfigurationSingleton.prototype._singletonInstance;
        }
        ClientApiConfigurationSingleton.prototype._singletonInstance = this;

        let settings = require('settings/settings');
        this.apiUrl = settings.externalDependencies.clientApiServerUrl;
    };

    return new ClientApiConfigurationSingleton();
});
